/* DESKTOP BUTTONS */
var readMoreButton = document.querySelector('.read-more-button-dt');
readMoreButton.addEventListener('click', function(event) {
  event.preventDefault();
  var descriptionFullMobile = document.querySelector('.collection-hero__description.mobile-only');
  descriptionFullMobile.classList.toggle("truncate")
  var descriptionFullDesktop = document.querySelector('.collection-hero__description.desktop-only');
  descriptionFullDesktop.classList.toggle("truncate");
  this.style.display = 'none';
  document.querySelector('.read-less-button-dt').style.display = 'block';
});

var readLessButton = document.querySelector('.read-less-button-dt');
readLessButton.addEventListener('click', function(event) {
  event.preventDefault();
  var descriptionFullMobile = document.querySelector('.collection-hero__description.mobile-only');
  descriptionFullMobile.classList.toggle("truncate")
  var descriptionFullDesktop = document.querySelector('.collection-hero__description.desktop-only');
  descriptionFullDesktop.classList.toggle("truncate");
  this.style.display = 'none';
  document.querySelector('.read-more-button-dt').style.display = 'block';
});  